import React, { useState, useEffect, useRef } from "react";
import { type IParentProps } from "@/types";

export interface IDropdownComponentProps extends IParentProps {
  menu: React.ReactElement;
  type?: "click" | "hover" | "sticky";
  disabled?: boolean;
  position?: string;
  className?: string;
}

const Dropdown: React.FC<IDropdownComponentProps> = ({
  children,
  className,
  menu,
  type = "click",
  position = "top-0 left-full",
  disabled,
}) => {
  const [open, setOpen] = useState(false);
  const compRef = useRef<HTMLDivElement>(null);

  const handleOuterClick = (event: MouseEvent) => {
    if (compRef.current && !compRef.current.contains(event.target as Node)) {
      setOpen(false);
    }
  };

  const clickAndCloseHandler: (func: () => void) => any = (func) => {
    return () => {
      func();
      setOpen(false);
    };
  };

  useEffect(() => {
    if (type === "click") {
      if (open) {
        document.addEventListener("click", handleOuterClick);
        return () => {
          document.removeEventListener("click", handleOuterClick);
        };
      }
    }
  }, [open]);

  return (
    <div
      ref={compRef}
      className="relative"
      onMouseLeave={() => {
        if (type === "hover") {
          setOpen(false);
        }
      }}
    >
      <span
        onClick={() => {
          if (type === "click" && !disabled) {
            setOpen(!open);
          }
        }}
        onMouseEnter={() => {
          if (type === "hover") {
            setOpen(true);
          }
        }}
      >
        {children}
      </span>
      {open && (
        <div
          className={`absolute bg-background text-foreground rounded-md shadow-lg mb-2 ${className} ${position}`}
          style={{ minWidth: "120px", zIndex: 2000 }} // Z-index is 71 because the Blockly workspace has a z-index of 70
        >
          {React.cloneElement(menu, { clickAndCloseHandler } as any)}
        </div>
      )}
    </div>
  );
};

export { Dropdown };
